import script from "./AssetsContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetsContainer.vue?vue&type=script&setup=true&lang=js"

import "./AssetsContainer.vue?vue&type=style&index=0&id=63d27b62&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63d27b62"]])

export default __exports__